import React, { useState , useRef } from "react";
import "./Roof_waterproofing_bituminous_sheets.css";
import { Link } from "react-router-dom";
import ContactSection2 from '../Category/ContactSection2';
import Adsense from "../Adsense";       // 🔥 ייבוא באנר דף הבית (או באנר כללי)
import InArticleAd from "../InArticleAd"; // 🔥 ייבוא המודעה החדשה לגוף המאמר

export default function Roof_sealing_with_pure_polyurethane_spraying() {


  return (

    <div className="Roof_waterproofing_bituminous_sheets-page">
      <div className="Roof_waterproofing_bituminous_sheets-hero">
        <div className="Roof_waterproofing_bituminous_sheets-overlay">
          <h1>     איטום גגות בהתזת פוליאוריטן טהור</h1>
        </div>
<div>
</div>
</div>
    <div className="page6">
 <div className="breadcrumb6">
  <Link to="/">בית</Link> /{" "}
  <Link to="/OurServices"> השירותים שלנו </Link>/{" "}
   <Link to="/Roof_sealing_with_pure_polyurethane_spraying">     איטום גגות בהתזת פוליאוריטן טהור</Link>{" "}
</div>
    </div>

      {/* CONTENT */}
<div className="page6">
  <div className="container">
            <div className="red-banner">
איטום גגות בהתזת פוליאוריטן טהור ובשיטת ננו-טכנולוגיה



</div>
    <div className="content-row2">



      <div className="text-box">


  <h2 className="info-title"> פוליאוריטן טהור הוא חומר איכותי ויקר מאוד האיטום בהתזה פוליאריטנית נעשה במקומות בהם אין גישה לביצוע עבודת איטום אחרת או לצורך בידוד חום וקור הוא מתבצע על קירות אופקיים ואנכיים כאחד החומר בעל כושר עמידות גבוהה מאוד שיוצר שכבה אחידה בכל שטח העבודה. 







</h2>




      </div>

    </div>




    <ContactSection2/>
<div className="links2">


  <Link to="/Sealing_underground_structures" className="link-right" >     איטום מבנים תת – קרקעיים 
</Link>
  <Link to="/Sealing_around_windows_in_a_variety_of_solutions" className="link-left" > איטום סביב חלונות במגוון פתרונות </Link>


</div>

      </div>
    </div>
  

      </div>
  );
}


